import React from 'react'

const Svg = ({ children, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
)

export const MailIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3.5 6.5 12 13l8.5-6.5" />
  </Svg>
)

export const LockIcon = (props) => (
  <Svg {...props}>
    <rect x="5" y="10.5" width="14" height="10" rx="2" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
    <path d="M12 14.5v2" />
  </Svg>
)

export const EyeIcon = (props) => (
  <Svg {...props}>
    <path d="M1.5 12S5.5 5 12 5s10.5 7 10.5 7-4 7-10.5 7S1.5 12 1.5 12Z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
)

export const EyeOffIcon = (props) => (
  <Svg {...props}>
    <path d="M17.9 17.9A10.1 10.1 0 0 1 12 19C5.5 19 1.5 12 1.5 12a18.6 18.6 0 0 1 5-5.9" />
    <path d="M9.9 5.2A9.1 9.1 0 0 1 12 5c6.5 0 10.5 7 10.5 7a18.5 18.5 0 0 1-2.2 3.2" />
    <path d="M14.1 14.1a3 3 0 1 1-4.2-4.2" />
    <path d="M2 2l20 20" />
  </Svg>
)

export const DocumentIcon = (props) => (
  <Svg {...props}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
    <path d="M14 3v5h5" />
    <path d="M9 13h6M9 17h6" />
  </Svg>
)

export const ChatIcon = (props) => (
  <Svg {...props}>
    <path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-4.5 3.5V17H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z" />
    <path d="M8 10h.01M12 10h.01M16 10h.01" />
  </Svg>
)

export const ShieldLockIcon = (props) => (
  <Svg {...props}>
    <path d="M12 3 19 6v5.5c0 4.4-3 8.2-7 9.5-4-1.3-7-5.1-7-9.5V6Z" />
    <circle cx="12" cy="11" r="1.7" />
    <path d="M12 12.7V15.5" />
  </Svg>
)

export const UsersIcon = (props) => (
  <Svg {...props}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
    <path d="M16 4.6a3.5 3.5 0 0 1 0 6.8M18 14.2a6.5 6.5 0 0 1 3.5 5.8" />
  </Svg>
)

export const GridIcon = (props) => (
  <Svg {...props}>
    <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
    <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
    <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
    <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
  </Svg>
)
